import { StyledFlex, TextView } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

import { AuthenticationDetails } from './CreateAssociationPanel.loader';
import { CreateAssociationQrCode } from './CreateAssociationQrCode';

type CreateAssociationPanelAuthenticationDetailsProps = {
   readonly authenticationDetails: AuthenticationDetails;
};

export const CreateAssociationPanelAuthenticationDetails = (
   props: CreateAssociationPanelAuthenticationDetailsProps
): JSX.Element => {
   return (
      <StyledFlex gap={'16px'}>
         <CreateAssociationQrCode
            secret={props.authenticationDetails.secret}
            label={props.authenticationDetails.label}
            issuer={props.authenticationDetails.issuer}
            windowLength={props.authenticationDetails.windowLength}
         />
         <StyledFlex direction={'column'} gap={'24px'} justifyContent={'center'}>
            <TextView testId={'accountName'} label={mfaSettingsTranslationKeys.accountName}>
               {props.authenticationDetails.label}
            </TextView>
            <TextView testId={'secret'} label={mfaSettingsTranslationKeys.secret}>
               {props.authenticationDetails.secret}
            </TextView>
         </StyledFlex>
      </StyledFlex>
   );
};
